import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"

export const List = styled("ul")`
    display: flex;
    flex-direction: row;
    margin: 0;
    padding: 0 1rem;
    padding-right: 0;
    align-items: start;
    height: inherit;
    flex-wrap: wrap;
    width: 100%;
    padding-left: 0.5rem;

    @media (min-width: ${breakpoints.values.lg}px) {
        flex-direction: column;
        flex-wrap: nowrap;
    }
`
export const Divider = styled("hr")`
    margin: 0.25rem 0.75rem;
`
